// Shared UI Library Components
import { CustomIcon, EIconName } from "@ppmcore/seven-ppm-core-shared-components-react";

export const CLayoutHeaderMenuList = [
  {
    label: 'Home',
    path: 'home',
    icon: <CustomIcon name={ EIconName.Home }/>,
    activeIcon: <CustomIcon name={ EIconName.HomeFill }/>
  },
  {
    label: 'Consultants',
    path: 'counsellors',
    icon: <CustomIcon name={ EIconName.Counsellors }/>,
    activeIcon: <CustomIcon name={ EIconName.CounsellorsFill }/>
  },
  {
    label: 'Transactions',
    path: 'transactions',
    icon: <CustomIcon name={ EIconName.TransactionsOff }/>,
    activeIcon: <CustomIcon name={ EIconName.TransactionsOn }/>
  },
  // {
  //   label: 'Refunds',
  //   path: 'refunds',
  //   icon: <CustomIcon name={ EIconName.Refund }/>,
  //   activeIcon: <CustomIcon name={ EIconName.Refund }/>
  // },
  {
    label: 'Business Profile',
    path: 'business-profile',
    icon: <CustomIcon name={ EIconName.BusinessData }/>,
    activeIcon: <CustomIcon name={ EIconName.BusinessDataFill }/>
  },
  // {
  //   label: 'Subscription',
  //   path: 'subscription',
  //   icon: <CustomIcon name={ EIconName.Subscription }/>,
  //   activeIcon: <CustomIcon name={ EIconName.SubscriptionFill }/>
  // },
  // {
  //   label: 'Rating',
  //   path: 'rating',
  //   icon: <CustomIcon name={ EIconName.CounsellorsRating }/>,
  //   activeIcon: <CustomIcon name={ EIconName.CounsellorsRatingFill }/>
  // },
  // {
  //   label: 'Clients',
  //   path: 'clients',
  //   icon: <CustomIcon name={ EIconName.Clients }/>,
  //   activeIcon: <CustomIcon name={ EIconName.ClientsFill }/>
  // },
  {
    label: 'Notifications',
    path: 'notifications',
    icon: <CustomIcon name={ EIconName.NotificationOff }/>,
    activeIcon: <CustomIcon name={ EIconName.NotificationOn }/>
  },
  // {
  //   label: 'FAQ',
  //   path: 'faq',
  //   icon: <CustomIcon name={ EIconName.QuestionMark }/>,
  //   activeIcon: <CustomIcon name={ EIconName.QuestionMarkFill }/>
  // },
];
